import { Session } from '../types/Session';

const LOCALE_OPTS: Intl.CollatorOptions = { sensitivity: 'base' };

export function getSessionAnchorTs(session: Session): number | null {
  let earliest: number | null = null;
  for (const cfg of session.configs ?? []) {
    for (const run of cfg.runs ?? []) {
      if (!run.run_ts) continue;
      const ts = Date.parse(run.run_ts);
      if (Number.isNaN(ts)) continue;
      if (earliest === null || ts < earliest) earliest = ts;
    }
  }
  return earliest;
}

function whenMs(session: Session): number {
  const anchor = getSessionAnchorTs(session);
  if (anchor !== null) return anchor;
  const d = session.date ? Date.parse(session.date) : NaN;
  return Number.isNaN(d) ? 0 : d;
}

function riderName(session: Session, ridersById?: Map<string, any>): string {
  return ridersById?.get(session.rider_id)?.nickname ?? '';
}

export function compareSessionsAsc(
  a: Session,
  b: Session,
  ridersById?: Map<string, any>,
): number {
  const wa = whenMs(a);
  const wb = whenMs(b);
  if (wa !== wb) return wa - wb;

  const ra = riderName(a, ridersById);
  const rb = riderName(b, ridersById);
  const byRider = ra.localeCompare(rb, undefined, LOCALE_OPTS);
  if (byRider !== 0) return byRider;

  const da = a.description ?? '';
  const db = b.description ?? '';
  return da.localeCompare(db, undefined, LOCALE_OPTS);
}

export function compareSessionsDesc(
  a: Session,
  b: Session,
  ridersById?: Map<string, any>,
): number {
  return -compareSessionsAsc(a, b, ridersById);
}
